import React from 'react';
import { ButtonWrapper, HeadingWrapper, Main } from './style';
var ErrorComponent = function (_a) {
    var onRetry = _a.onRetry;
    return (React.createElement(Main, { "data-testid": "error-component" },
        React.createElement(HeadingWrapper, { size: { mobile: 'xs', tablet: 'sm' }, color: "shade.700", mb: "sm" }, "Ooooops"),
        React.createElement(HeadingWrapper, { size: { mobile: 'xs', tablet: 'sm' }, color: "shade.700", mb: "lg" }, "Something went wrong."),
        onRetry && (React.createElement(ButtonWrapper, { variant: "primary", onClick: onRetry }, "TRY AGAIN"))));
};
export default ErrorComponent;
//# sourceMappingURL=index.js.map